import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { PageWrapper, Loader, Alert, Pagination } from "../../components";
import Actions, { thunks } from "../../redux/modules/uploadedOrders";
import { formatDateTime } from "../../utils/format";
import { UPLOAD_ORDERS_STATUS } from "../../constants";
import DetailsModal from "./components/detailsModal";

class UploadedOrders extends React.Component {
  state = {
    orderToDelete: null,
  };
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(thunks.getUploadedOrders());
  }

  viewUploadedOrder = (order) => {
    const { updateProperty } = this.props;
    updateProperty("data", order);
  };

  onNext = () => {
    const { dispatch } = this.props;
    dispatch(thunks.loadMoreOrders());
  };

  onStatusChange = (e) => {
    e.preventDefault();
    const { dispatch, updateProperty } = this.props;
    updateProperty("status", e.target.value);
    dispatch(thunks.getUploadedOrders());
  };

  uploadQuotation = (data) => {
    const { dispatch } = this.props;
    dispatch(thunks.uploadQuotation(data));
  };

  delete = (user) => {
    this.setState({ orderToDelete: user });
  };

  handleDelete = () => {
    const { dispatch } = this.props;
    const { orderToDelete } = this.state;
    dispatch(thunks.deleteOrders(orderToDelete.id));
    this.setState({ orderToDelete: null });
  };

  render() {
    const {
      list,
      loading,
      error,
      updateProperty,
      nextPageToken,
      status,
      data,
    } = this.props;
    const { orderToDelete } = this.state;

    return (
      <PageWrapper title="Uploaded Orders List">
        <Loader show={loading} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title="Uploaded Orders"
          message={error}
        />
        <div className="animated fadeIn">
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Status</label>
                        <select
                          className="form-control"
                          value={status}
                          onChange={this.onStatusChange}
                        >
                          {UPLOAD_ORDERS_STATUS.map((status) => (
                            <option key={status.value} value={status.value}>
                              {status.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Status</th>
                          <th>Updated On</th>
                          <th>Created On</th>
                          <th />
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {list.length ? (
                          list.map((order) => (
                            <tr key={order.id}>
                              <td>{order.id}</td>
                              <td>
                                {
                                  UPLOAD_ORDERS_STATUS.find(
                                    (status) => status.value === order.status
                                  ).name
                                }
                              </td>
                              <td>{formatDateTime(order.updatedOn)}</td>
                              <td>{formatDateTime(order.createdOn)}</td>
                              <td>
                                <button
                                  title="View Order"
                                  className="btn btn-xs btn-info"
                                  onClick={() => this.viewUploadedOrder(order)}
                                >
                                  <i className="fa fa-eye" />
                                </button>
                              </td>

                              <td>
                                {
                                  <button
                                    title="View User"
                                    className="btn btn-xs btn-danger"
                                    onClick={() => this.delete(order)}
                                  >
                                    <i className="fa fa-trash" />
                                  </button>
                                }
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination
                    nextPageToken={nextPageToken}
                    onNext={this.onNext}
                  />
                </div>
                <DetailsModal
                  data={data}
                  updateProperty={updateProperty}
                  uploadQuotation={this.uploadQuotation}
                />
              </div>
            </div>
          </div>
        </div>

        <Alert
          show={!!orderToDelete}
          onHide={() => this.setState({ orderToDelete: null })}
          title="Delete Order"
          message={`Are you sure you want to delete Uploaded Order: ${
            (orderToDelete || {}).id
          }?`}
          onSubmit={this.handleDelete}
        />
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({
  uploadedOrders: { loading, error, list, status, nextPageToken, data },
}) => ({
  loading,
  error,
  list,
  nextPageToken,
  status,
  data,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
  updateProperties: bindActionCreators(Actions, dispatch).updateProperties,
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadedOrders);
